import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const I_KEYBOARDING_MODULE_VIDEO_FRAGMENT = gql `
  fragment KeyboardingModuleVideoFragment on KeyboardingModuleVideo {
    id
    name
    description
    videoId
    video {
      ...AssetFragment
    }
    moduleId
  }
  ${ASSET_FRAGMENT}
`;
export default I_KEYBOARDING_MODULE_VIDEO_FRAGMENT;
